/** No public keys go here and nothing else! */
export const FB_APP_ID = '354904741335190';
export const GOOGLE_CLIENT_ID =
  '1092568288730-ec49d3un0ocr8kvld567ls2kea92f50t.apps.googleusercontent.com';
export const SWS_CLIENT_ID = '90989a0528ad4b238480f1ac0f5855e5';
export const STRIPE_KEY = 'pk_live_ji1OgCXmnDq00hPzClTbgnQZ';
export const STRIPE_KEY_DEV = 'pk_test_QGnVFbcYrrVg01bZ9NvOWoG6007qcPJfeQ';
export const HOTJAR_HJID = 44113;
export const HOTJAR_HJSV = 6;
export const REWARDFUL_API_KEY = 'd92841';
export const REWARDFUL_TRACKING_URL = 'https://r.wdfl.co/rw.js';
export const USERPILOT_URL = 'https://js.userpilot.io/sdk/latest.js';
export const USERPILOT_TOKEN = 'NX-c58d9705';
export const BRAZE_PROD_API_KEY = 'e32ab9b0-7a06-40f3-919b-6c08c1447e63';
export const BRAZE_PROD_SDK_ENDPOINT = 'sdk.iad-05.braze.com';
export const BRAZE_DEV_API_KEY = '1dd6db5d-62c0-4891-97ac-f2ca9d8d8423';
export const BRAZE_DEV_SDK_ENDPOINT = 'sdk.iad-05.braze.com';

/** dev */
// export const STRIPE_KEY = 'pk_test_QGnVFbcYrrVg01bZ9NvOWoG6007qcPJfeQ';
export const AUTH_SCOPE =
  'public read:user write:user read:portfolio write:portfolio';
export const SENTRY_DSN =
  'https://8d2df8974aac4e88bf2faa04c30679bc@o109478.ingest.sentry.io/1469220';
export const SENTRY_CAPACITOR_DSN =
  'https://5a95485974124435b545ea40e645c6b7@o109478.ingest.sentry.io/6000432';
/** Use 'kz2avr3wo2m5ghhb8' to toss a coin */
export const FEATURE_KEYS =
  'kfrofp7n8rngnrhhn,kba3aqaofbayywb8y,kcpbzyv9a5pi53iri,k4nbq85spehorf6vh,kamxxia8fwyiy7u9r,kynd11oevrpz7mite,krz2oi4rh7uw2bsrr,kp9qakiq8o2rm8xur,kpec1ps8548ne258c,k7xnynx3t9idi9iwu,ktrprrfwaa8hk21kd';
export const ALGOLIA_API_KEY = 'be7c37718f927d0137a88a11b69ae419';
export const ALGOLIA_APP_ID = '17IQHZWXZW';
export const GETSTREAM_API_KEY = 'c2jdvmk9p547';
export const GETSTREAM_APP_ID = '73819';
export const CONTENTFUL_SPACE = 'n07nr2koi959';
export const CONTENTFUL_ACCESS_TOKEN =
  'ZIsU9i6Drg1khCUoISG89DpBVEVCM-OR93vjxNXwNHc';
export const AUTHOR_HUB_ID = '1P2S29V0zldGNE6PC5h2mU';
export const CONTENTFUL_GRAPQL =
  'https://graphql.contentful.com/content/v1/spaces/';
export const FASTCOMMENTS_APP_ID = 'W5Yi5xT_IaG';

export const UNLEASH_PROXY_URL_DEV =
  'https://mono-stable.dev.simplywall.st/backend/flags/proxy';
export const UNLEASH_PROXY_URL_STAGING =
  'https://staging.simplywall.st/backend/flags/proxy';
export const UNLEASH_PROXY_URL_PROD =
  'https://simplywall.st/backend/flags/proxy';
